"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _warehouse = require("@/api/warehouse");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _reportExpiredExcel = require("./components/report-expired-excel");
var _date = require("@/utils/date");
var ReportExpiredWarehouse = /*#__PURE__*/function (_Vue) {
  function ReportExpiredWarehouse() {
    var _this;
    (0, _classCallCheck2.default)(this, ReportExpiredWarehouse);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReportExpiredWarehouse, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "dataExport", []);
    return _this;
  }
  (0, _inherits2.default)(ReportExpiredWarehouse, _Vue);
  return (0, _createClass2.default)(ReportExpiredWarehouse, [{
    key: "transformData",
    get: function get() {
      var data = [];
      this.data.forEach(function (e) {
        var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
          rowspan: 0
        });
        data.push(temp);
      });
      var count = 0;
      data.forEach(function (element, index) {
        count++;
        if (index < data.length - 1 && element.productId != data[index + 1].productId) {
          data[index + 1 - count].rowspan = count;
          count = 0;
        }
      });
      if (data.length) {
        data[data.length - count].rowspan = count;
      }
      return data;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "getExpired",
    value: function getExpired(date) {
      return (0, _date.diffDayFromToday)(date);
    }
  }, {
    key: "getPercentExpired",
    value: function getPercentExpired(data) {
      return (0, _date.percentFromCurrentToExpired)(data.expired, data.dateOfManufacture);
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      _warehouse.warehouseApi.findAllExpired(this.query).then(function (res) {
        _this2.data = res.data;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "fetchDataExport",
    value: function () {
      var _fetchDataExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(type) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _warehouse.warehouseApi.findAllExpired(this.query);
            case 2:
              res = _context.sent;
              (0, _reportExpiredExcel.reportExpiredWarehouseExcel)({
                data: res.data
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchDataExport(_x) {
        return _fetchDataExport.apply(this, arguments);
      }
      return fetchDataExport;
    }()
  }, {
    key: "objectSpanMethod",
    value: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    }
  }, {
    key: "tableRowClassName",
    value: function tableRowClassName(_ref2) {
      var row = _ref2.row,
        rowIndex = _ref2.rowIndex;
      // get khoảng thời gian sử dụng của sản phẩm
      var totalMonthToExpired = _moment.default.unix(row.expired).diff(_moment.default.unix(row.dateOfManufacture), "months");
      // get thời gian sản phẩm sắp hết hạn
      var remainMonth = this.getExpired(row.expired);
      var isWarning = false;
      var isDanger = false;
      if (totalMonthToExpired <= 24) {
        // check sản phẩm có hạn 2 năm
        isWarning = remainMonth <= 12 && remainMonth > 6;
        isDanger = remainMonth <= 6;
      }
      if (totalMonthToExpired <= 36 && totalMonthToExpired > 24) {
        // check sản phẩm có hạn 3 năm
        isWarning = remainMonth <= 18 && remainMonth > 6;
        console.log("isWarning:", isWarning);
        isDanger = remainMonth <= 6;
      }
      if (isWarning) {
        return "row-warning";
      }
      if (isDanger || remainMonth < 0) {
        return "row-danger";
      }
      return "";
    }
  }]);
}(_vuePropertyDecorator.Vue);
ReportExpiredWarehouse = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], ReportExpiredWarehouse);
var _default = exports.default = ReportExpiredWarehouse;